<template>
  <div class="main-box">
    <div style="height: 60px"></div>
    <div>
      <el-input v-model="name" placeholder="Please input">
        <template #prepend>请输入新的友情来链接名称</template>
      </el-input>
    </div>
    <div style="height: 20px"></div>
    <div>
      <el-input v-model="url" placeholder="Please input">
        <template #prepend>请输入新的友情来链接网址</template>
      </el-input>
    </div>
    <div style="height: 20px"></div>
    <div style="text-align: center">
      <el-button @click="admit" type="primary">提交</el-button>
    </div>
  </div>

</template>
<script>
import time from '@/core/time.js';
import ClassicEditor from "@/ckeditor/ckeditor";
import {ElLoading} from "element-plus";



export default {
  data() {
    return {
      id:'',
      name:'',
      url:''
    }
  },
  watch: {
    $route(to, from) {
      window.location.reload(); //监测到路由发生跳转时刷新一次页面
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.getDataById();
  },
  mounted() {

  },
  methods: {
    getDataById(){
      this.$request.post('/FileUpload/getDataById', this.id).then(res=>{
      this.name=res.obj.name;
      this.url=res.obj.url;
      })
    },
    admit() {
      if(this.name==''){
        this.$msg.warning('请输入链接名称')
      }else if(this.url==''){
        this.$msg.warning('请输入链接地址')
      }else {
        let data = {
          id: this.id,
          name:this.name,
          url: this.url,
        }
        let url = '/FileUpload/UpdateUrl'
        this.$request.post(url, data);
          this.$msg.success('提交成功');
          this.$router.push({
            path:'/fileKindList',
          })
      }

    },

  }
}
</script>
<style lang="less">
.main-box{
  width: 60%;
  min-height: 400px;
  margin: 0 auto;
}


</style>